import { styled as m } from "@mui/material";
import { CurrencyTokenType as s } from "../../currency-lib/constants/currency.js";
import { useCurrencyContext as u } from "../../currency-lib/contexts/CurrencyContext.js";
import p from "./ApeironGotoRoundButton.js";
import { useMemo as a } from "react";
import { useTranslation as c } from "react-i18next";
import { jsx as d } from "react/jsx-runtime";
const g = m(p)`
  .Custom-Container {
    background-color: unset;
    background: url('') padding-box,
      linear-gradient(to right, #feecd1, #dba777) border-box;

    .Custom-Link {
      .Custom-Icon-Text {
        gap: 4px;
        .Custom-Icon {
          margin-left: -2px;

          ${(o) => o.theme.breakpoints.up("res768")} {
            width: 70px;
          }
          ${(o) => o.theme.breakpoints.down("res768")} {
            width: 50px;
          }
        }
      }
    }
  }
`, y = (o) => {
  const {
    url: e,
    target: n
  } = o, {
    getCurrency: r
  } = u(), t = a(() => r(s.Stardust), [r]), {
    t: i
  } = c();
  return /* @__PURE__ */ d(g, {
    icon: (t == null ? void 0 : t.image) || "",
    url: e,
    target: n,
    text: i("goto.check_in")
  });
};
export {
  y as default
};
//# sourceMappingURL=GotoCheckIn.js.map
